function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultPaymenti = function SvgDefaultPaymenti(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M19.817 9.506a7.47 7.47 0 0 1 1.065 3.856 7.52 7.52 0 0 1-11.076 6.62.736.736 0 0 0-.699 1.295 8.94 8.94 0 0 0 4.259 1.073c4.96 0 8.987-4.027 8.987-8.988A8.94 8.94 0 0 0 21.08 8.75a.737.737 0 0 0-1.262.756M10.31 1.65c4.781 0 8.663 3.881 8.663 8.662s-3.882 8.664-8.663 8.664-8.663-3.882-8.663-8.664S5.528 1.65 10.31 1.65m0 1.47c3.97 0 7.192 3.223 7.192 7.192s-3.223 7.193-7.192 7.193-7.192-3.223-7.192-7.193S6.34 3.121 10.31 3.121M8.89 12.563l4.007-5.416a.735.735 0 1 1 1.182.874l-4.515 6.103a.736.736 0 0 1-1.11.082l-2.745-2.743a.736.736 0 0 1 1.04-1.04z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultPaymenti);
export default ForwardRef;